import { render } from "./StoragePage.vue?vue&type=template&id=0daaa718"
import script from "./StoragePage.vue?vue&type=script&lang=js"
export * from "./StoragePage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__